import { useCallback } from 'react';
import { useRecoilCallback } from 'recoil';
import { useQueryClient } from '@tanstack/react-query';
import { clearCompanyData } from '../utils/clearCompanyData';
import { resetGlobalInitialization } from './useInitializeSiteAndCamera';
import {
  siteState,
  cameraState,
  dateRangeState,
  dateValueState,
  selectedOrdersState,
  selectedSpeciesState,
  speciesFilterModeState,
  speciesPercentageDateRangeState,
  dateRangeAdjustedState,
  speciesListState,
} from '../state/statistics.state';

export function useResetAppState(): () => void {
  const queryClient = useQueryClient();

  const resetRecoilState = useRecoilCallback(
    ({ reset }) =>
      () => {
        reset(siteState);
        reset(cameraState);
        reset(dateRangeState);
        reset(dateValueState);
        reset(selectedOrdersState);
        reset(selectedSpeciesState);
        reset(speciesFilterModeState);
        reset(speciesPercentageDateRangeState);
        reset(dateRangeAdjustedState);
        reset(speciesListState);
      },
    [],
  );

  const resetAppState = useCallback((): void => {
    clearCompanyData();
    resetRecoilState();
    resetGlobalInitialization();
    queryClient.clear();
  }, [queryClient, resetRecoilState]);

  return resetAppState;
}
